import React from 'react'
import ReactDOM from 'react-dom'
import { notification } from 'antd'
import App from './App'
import { zapniServiceWorker } from './pwa/registracia'

ReactDOM.render(<App />, document.getElementById('root'))

// Service worker sa zapina IBA na mobilnej casti. Na pocitaci by nic
// nepriniesol (stranka sa tam z pamate neotvara) a pritom by sa dotkol
// kazdeho, kto administraciu pouziva. Takto sa na pocitaci nemeni nic.
//
// Aplikacia pridana na plochu si obal drzi v pamati telefonu, takze po
// nasadeni novej verzie by inac clovek este dlho pouzival tu starú a
// hlasil chyby, ktore su uz davno opravene. Toto mu dá o novej vediet
// a nechá rozhodnutie na neho, nech mu to nezhodí rozpisanú prácu.
if (window.location.pathname.startsWith('/mobil')) {
  zapniServiceWorker({
    naNovuVerziu: prevezmi => {
      notification.info({
        message: 'Je nová verzia',
        description: 'Tuknite sem a aplikácia sa načíta znova.',
        duration: 0,
        onClick: prevezmi
      })
    }
  })
}
